import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.WeeklyOverview.header',
    defaultMessage: 'Weekly Overview',
  },
  noShifts: {
    id: 'app.containers.WeeklyOverview.noShifts',
    defaultMessage: 'No shifts',
  },
  noPublishers: {
    id: 'app.containers.WeeklyOverview.noPublishers',
    defaultMessage: 'No publishers assigned',
  },
  teamLead: {
    id: 'app.containers.WeeklyOverview.teamLead',
    defaultMessage: 'Team Lead',
  },
  assignmentStateChanged: {
    id: 'app.containers.WeeklyOverview.assignmentStateChanged',
    defaultMessage: 'Changed',
  },
  assignmentStateCommitted: {
    id: 'app.containers.WeeklyOverview.assignmentStateCommitted',
    defaultMessage: 'Planned',
  },
  assignmentStateFinalized: {
    id: 'app.containers.WeeklyOverview.assignmentStateFinalized',
    defaultMessage: 'Published',
  },
  turnFallbackName: {
    id: 'app.containers.WeeklyOverview.turnFallbackName',
    defaultMessage: 'Turn {turnId}',
  },
  multipleAssignments: {
    id: 'app.containers.WeeklyOverview.multipleAssignments',
    defaultMessage: 'Multiple assignments',
  },
  unassignedApplicants: {
    id: 'app.containers.WeeklyOverview.unassignedApplicants',
    defaultMessage: 'Unassigned',
  },
  assignmentCount: {
    id: 'app.containers.WeeklyOverview.assignmentCount',
    defaultMessage: '{count, plural, one {# assignment} other {# assignments}}',
  },
  applicationCount: {
    id: 'app.containers.WeeklyOverview.applicationCount',
    defaultMessage:
      '{count, plural, one {# application} other {# applications}}',
  },
});
